import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, Typography, Button, Alert } from '@mui/material';

/**
 * Component to handle OAuth error redirects
 * 
 * Displays the error message and provides a button to return to login
 */
const AuthError: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [errorMessage, setErrorMessage] = useState<string>('Authentication failed');
  
  useEffect(() => {
    // Get error message from URL query parameters
    const params = new URLSearchParams(location.search);
    const message = params.get('message');
    
    if (message) {
      setErrorMessage(decodeURIComponent(message));
    }
  }, [location.search]);
  
  const handleReturnToLogin = () => {
    navigate('/login', { replace: true });
  };
  
  return (
    <Box 
      sx={{ 
        display: 'flex', 
        flexDirection: 'column',
        alignItems: 'center', 
        justifyContent: 'center',
        minHeight: '100vh',
        bgcolor: 'background.default',
        padding: 3
      }}
    >
      <Alert severity="error" sx={{ mb: 4, width: '100%', maxWidth: 500 }}>
        {errorMessage}
      </Alert>
      
      <Typography variant="h5" component="h1" gutterBottom>
        Authentication Error
      </Typography>
      
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4, textAlign: 'center' }}>
        There was a problem signing you in. Please try again.
      </Typography>
      
      <Button 
        variant="contained" 
        color="primary" 
        onClick={handleReturnToLogin}
        size="large"
      >
        Return to Login
      </Button>
    </Box>
  );
};

export default AuthError; 